<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useQuizterStore } from '../stores/quizterStore';
import Card from './Card.vue';
import NextButton from './NextButton.vue';
import useLocale from '../../composables/use-locale';
import { configHelper } from '@ilteducation/config';

const { t } = useLocale();

const quizterStore = useQuizterStore();
const { returnParams } = storeToRefs(quizterStore);

const goToQuizter = () => {
  quizterStore.reset();
  // Check environment, if staging => dev.quizter.gg, else quizter.gg
  if (configHelper.environment() === 'production') {
    window.location.href = 'https://quizter.gg';
  } else {
    window.location.href = 'https://dev.quizter.gg';
  }
};
</script>

<template>
  <Card max-width="500" data-testid="quizter-game-not-found">
    <div class="d-flex flex-column align-center justify-center pa-4 mt-8">
      <div class="d-flex flex-column align-center gr-4">
        <v-icon icon="fa:fawsb fa-clock" size="64"></v-icon>

        <div class="d-flex flex-column align-center ga-3">
          <h1 class="chalkduster-font text-center text-h5 ma-0">
            {{ t('game_not_found.title') }}
          </h1>
          <p class="chalkboard-font text-center text-body-1 ma-0">
            {{ t('game_not_found.description') }}
          </p>
        </div>
      </div>

      <div class="d-flex flex-column align-center ga-3 mt-12">
        <!-- Go back to app if returnParams available -->
        <NextButton v-if="returnParams" :href="returnParams.url" @click="quizterStore.reset">
          {{ returnParams.text }}
        </NextButton>
        <NextButton v-else @click="goToQuizter">
          {{ t('game_not_found.button_go_to_quizter') }}
        </NextButton>
      </div>
    </div>
  </Card>
</template>
